/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  let sealSubsObserverStarted = false;

  function applySealSubsPriceClass(root) {
    (root || document).querySelectorAll('.sealsubs-target-element span.money.conversion-bear-money.seal-money.ht-money').forEach((price) => {
      price.classList.add('purchase-option-pricex');
    });
  }

  function initSealSubsPriceClassing() {
    applySealSubsPriceClass(document);

    if (sealSubsObserverStarted || !document.body) return;

    const observer = new MutationObserver(() => {
      applySealSubsPriceClass(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    sealSubsObserverStarted = true;
  }

  function resetHoverMegaPreview(panel) {
    if (!panel || !panel.hasAttribute('data-hb-default-panel')) return;

    const previewContainer = panel.querySelector('[data-hb-preview-container]');
    if (previewContainer) {
      previewContainer.hidden = true;
    }
  }

  function updateHoverMegaPreview(panel, link) {
    if (!panel || !link) return;

    const previewContainer = panel.querySelector('[data-hb-preview-container]');
    const previewCard = panel.querySelector('[data-hb-preview-card]');
    if (!previewCard) return;

    const previewMedia = previewCard.querySelector('[data-hb-preview-media]');
    const previewTitle = previewCard.querySelector('[data-hb-preview-title]');
    const previewPrice = previewCard.querySelector('[data-hb-preview-price]');
    const imageUrl = link.getAttribute('data-hb-product-image') || '';
    const imageAlt = link.getAttribute('data-hb-product-image-alt') || link.dataset.hbProductTitle || '';

    if (link.dataset.hbProductUrl) {
      previewCard.href = link.dataset.hbProductUrl;
    }

    if (previewTitle) {
      previewTitle.textContent = link.dataset.hbProductTitle || '';
    }

    if (previewPrice) {
      previewPrice.textContent = link.dataset.hbProductPrice || '';
    }

    if (previewContainer) {
      previewContainer.hidden = false;
    }

    if (previewMedia) {
      if (imageUrl) {
        const previewImage = document.createElement('img');
        previewImage.className = 'hb-mega-preview-card__image';
        previewImage.loading = 'eager';
        previewImage.decoding = 'async';
        previewImage.alt = imageAlt;
        previewImage.src = imageUrl;
        previewImage.setAttribute('data-hb-preview-image', '');

        previewMedia.replaceChildren(previewImage);
        previewMedia.hidden = false;
      } else {
        previewMedia.replaceChildren();
        previewMedia.hidden = true;
      }
    }
  }

  function initHoverMegaMenu(menu) {
    if (!menu || menu.dataset.hbMegaReady === 'true') return;

    const families = Array.from(menu.querySelectorAll('.hb-mega-family'));
    const defaultPanel = menu.querySelector('[data-hb-default-panel]');
    const defaultPanelProductLinks = defaultPanel ? Array.from(defaultPanel.querySelectorAll('.hb-mega-product-link')) : [];
    if (!families.length) return;

    const clearActive = () => {
      menu.classList.remove('hb-mega-menu--has-active-family');
      families.forEach((family) => family.classList.remove('is-active'));
      resetHoverMegaPreview(defaultPanel);
    };

    const setActive = (activeFamily) => {
      menu.classList.toggle('hb-mega-menu--has-active-family', Boolean(activeFamily));

      families.forEach((family) => {
        family.classList.toggle('is-active', family === activeFamily);
      });
    };

    families.forEach((family) => {
      const panel = family.querySelector('.hb-mega-products__panel');
      const productLinks = panel ? Array.from(panel.querySelectorAll('.hb-mega-product-link')) : [];
      const defaultProductLink = productLinks[0] || null;

      if (panel && defaultProductLink) {
        updateHoverMegaPreview(panel, defaultProductLink);
      }

      family.addEventListener('mouseenter', () => {
        setActive(family);

        if (panel && defaultProductLink) {
          updateHoverMegaPreview(panel, defaultProductLink);
        }
      });

      family.addEventListener('focusin', (event) => {
        setActive(family);

        if (!panel) return;

        const focusedProductLink = event.target.closest('.hb-mega-product-link');
        updateHoverMegaPreview(panel, focusedProductLink || defaultProductLink);
      });

      productLinks.forEach((productLink) => {
        productLink.addEventListener('mouseenter', () => updateHoverMegaPreview(panel, productLink));
        productLink.addEventListener('focusin', () => updateHoverMegaPreview(panel, productLink));
      });
    });

    defaultPanelProductLinks.forEach((productLink) => {
      productLink.addEventListener('mouseenter', () => updateHoverMegaPreview(defaultPanel, productLink));
      productLink.addEventListener('focusin', () => updateHoverMegaPreview(defaultPanel, productLink));
    });

    menu.addEventListener('mouseleave', clearActive);
    menu.addEventListener('focusout', (event) => {
      const nextFocusedElement = event.relatedTarget;

      if (!nextFocusedElement || !menu.contains(nextFocusedElement)) {
        clearActive();
      }
    });

    menu.dataset.hbMegaReady = 'true';
  }

  function initHoverMegaMenus(root) {
    root.querySelectorAll('.header__dropdown__inner.hb-mega-menu').forEach(initHoverMegaMenu);
  }

  function setMobileShopMenuExpanded(menu, expanded) {
    if (!menu) return;

    const toggle = menu.querySelector('[data-hb-mobile-shop-toggle]');
    const panel = menu.querySelector('[data-hb-mobile-shop-panel]');

    menu.classList.toggle('is-open', expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (panel) {
      panel.hidden = !expanded;
    }

    if (!expanded) {
      menu.querySelectorAll('[data-hb-mobile-shop-group]').forEach((group) => {
        setMobileShopGroupExpanded(group, false);
      });
    }
  }

  function setMobileShopGroupExpanded(group, expanded) {
    if (!group) return;

    const toggle = group.querySelector('[data-hb-mobile-shop-group-toggle]');
    const panel = group.querySelector('[data-hb-mobile-shop-group-panel]');

    group.classList.toggle('is-open', expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (panel) {
      panel.hidden = !expanded;
    }
  }

  function initMobileShopMenu(menu) {
    if (!menu || menu.dataset.hbMobileShopReady === 'true') return;

    const rootToggle = menu.querySelector('[data-hb-mobile-shop-toggle]');

    if (rootToggle) {
      rootToggle.addEventListener('click', () => {
        const expanded = rootToggle.getAttribute('aria-expanded') !== 'true';
        setMobileShopMenuExpanded(menu, expanded);
      });
    }

    menu.querySelectorAll('[data-hb-mobile-shop-group]').forEach((group) => {
      const toggle = group.querySelector('[data-hb-mobile-shop-group-toggle]');

      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        setMobileShopGroupExpanded(group, expanded);
      });
    });

    menu.dataset.hbMobileShopReady = 'true';
  }

  function initMobileShopMenus(root) {
    root.querySelectorAll('[data-hb-mobile-shop-menu]').forEach(initMobileShopMenu);
  }

  function bootCustomMenus(root) {
    applySealSubsPriceClass(root || document);
    initHoverMegaMenus(root || document);
    initMobileShopMenus(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootCustomMenus(document));
  } else {
    bootCustomMenus(document);
  }

  initSealSubsPriceClassing();

  document.addEventListener('shopify:section:load', (event) => {
    bootCustomMenus(event.target);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
